module.exports = __webpack_public_path__ + "static/media/DownloadSVG.31922aa9.svg";